import Collapse from '@mui/material/Collapse';

export { Collapse };
